module.exports = __webpack_public_path__ + "assets-cabinet/img/send.e3d2396a.svg";